<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="back($event)"
    >
    <mat-tab [label]="matTabTitle">
      <div class="w-100 mt-4">
        <data-table
          [columns]="columnasOT"
          [data]="dataOT"
          [configuration]="configurationOT"
          [reloadTable]="recargarTablaOT"
          [params]="params"
          [url]="urlTablaOT"
          (add)="agregarOT()"
          (edit)="editarOT($event)"
          (delete)="eliminarOT($event)"
          (print)="print($event)"
          (selection)="seleccionadosOT($event)"
          (clickRow)="clickFilaOT($event)"
          (packOff)="packOff($event)"
          [headerFilters]="headerFilters"
          (addComment)="addCommentService($event)"
          (view)="viewDetailService($event)"
        ></data-table>
      </div>
    </mat-tab>

    @if (selected.value == 1) {
      <mat-tab label="Detalle">
        <app-work-order-summary [workOrderDetails]="detailsClickRow">
        </app-work-order-summary>
      </mat-tab>
    }
  </mat-tab-group>
</div>
